/* eslint-disable react-native/no-unused-styles */
/* eslint-disable react-native/no-color-literals */
/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/prop-types */
/*
Author: Gilang Romadhanu Tartila
*/

import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { View, StyleSheet, TouchableOpacity } from 'react-native';
import SociollaText from '@components/sociolla/SociollaText';
import Colors from '@global/colors';
import Button from '@components/form/Button';
import Photo from '@components/global/Photo';
import ItemDetail from '@components/global/ItemDetail';
import TableMobile from '@components/table/TableMobile';
import Table from '@components/table/Table';
import * as Layout from '@components/screen/Layout';
import { isWeb } from '@global/screens';
import StatusBadge from '@components/global/StatusBadge';

import useApi from '@/hooks/useApi';
import { MsAccount } from '@api/ms-account';

const photoSize = 40;

const BranchListDetailScreen = (props) => {
  const userData = useSelector((state) => state.auth.user);
  const userRole = userData?.role?.code;
  const [activeTab, setActiveTab] = useState(1);
  const [warehouses, setWarehouses] = useState([]);
  const [teamMembers, setTeamMembers] = useState([]);
  const [teamMembersTemp, setTeamMembersTemp] = useState([]);
  const [detailData, setDetailData] = useState({});

  const getBranchDetail = useApi(MsAccount.getBranchDetail);

  const getDetail = async (id) => {
    const response = await getBranchDetail.request(id);
    if (response?.data?.data && Object.keys(response.data.data).length) {
      const result = response.data.data;
      result.is_active = result.is_active ? 'active' : 'in_active';
      if (result?.sales_team?.length) {
        const whTemp = [];
        let tmTemp = [];
        for (let i = 0; i < result.sales_team.length; i++) {
          const sales = result.sales_team[i];
          if (sales) {
            if (sales.warehouse && sales.warehouse.name) {
              if (whTemp.indexOf(sales.warehouse.name) == -1) {
                const arrwh = [sales.warehouse];
                const arrwhoptional = sales.optional_warehouse;
                const arrpushwh = arrwh.concat(arrwhoptional);
                if (arrwhoptional === undefined) {
                  whTemp.push(sales.warehouse.name);
                } else {
                  arrpushwh.forEach(function (item) {
                    whTemp.push(item.name);
                  });
                }
              }
            }
            if (sales.team_members && sales.team_members.length) {
              const tm_filtered = sales.team_members.filter(
                (m) => tmTemp.findIndex((t) => t.email == m.email) == -1,
              );
              if (tm_filtered.length) {
                tmTemp = tmTemp.concat(tm_filtered);
              }
            }
          }
        }
        setWarehouses(whTemp);
        setTeamMembersTemp(tmTemp);
        setTeamMembers(tmTemp);
      }
      setDetailData(result);
    } else {
      setDetailData({});
    }
  };

  useEffect(() => {
    const unsubscribe = props.navigation.addListener('focus', () => {
      setActiveTab(1);
      setDetailData({});
      if (props?.route?.params?.id) {
        getDetail(props.route.params.id);
      }
    });
    return unsubscribe;
  }, [props]);

  const tabs = [
    { key: 1, name: 'Detail' },
    { key: 2, name: 'Team Member' },
  ];

  const tableStructure = {
    name: {
      head: 'Name',
      body: 'name',
      type: 'slot',
      textStyle: { fontFamily: 'figtree-medium' },
    },
    email: {
      head: 'Email',
      body: 'email',
    },
    sales_code: {
      head: 'Sales Code',
      body: 'sales_code',
    },
  };

  const goToForm = () => {
    if (detailData._id) {
      props.navigation.navigate('BranchListFormScreen', {
        titleScreen: detailData.name,
        name: detailData.name,
        id: detailData._id,
      });
    }
  };

  const goToTeamDetail = (data) => {
    if (detailData._id) {
      props.navigation.navigate('ProfileNavigator', {
        screen: 'ProfileScreen',
        params: {
          id: data.id,
          name: data.name,
          titleScreen: data.name,
          branchId: detailData._id,
          branchName: detailData.name,
        },
      });
    }
  };

  const onSearch = (keyword) => {
    if (keyword) {
      const result = teamMembersTemp.filter(
        (item) =>
          item.name &&
          item.name.toLowerCase().indexOf(keyword.toLowerCase()) > -1,
      );
      setTeamMembers(result);
    } else {
      setTeamMembers(teamMembersTemp);
    }
  };

  return (
    <Layout.Container>
      {isWeb ? (
        <Layout.Back
          title="Branch List"
          onCallback={() => props.navigation.navigate('BranchListScreen')}
        />
      ) : (
        false
      )}
      <Layout.Wrapper rounded>
        {getBranchDetail && getBranchDetail.loading ? (
          <Layout.Loader />
        ) : (
          <>
            <Layout.Title
              title={detailData.name}
              style={{
                paddingTop: isWeb ? 25 : 15,
                paddingHorizontal: isWeb ? 25 : 15,
              }}>
              {isWeb &&
              ![
                'regional_manager',
                'regional_support',
                'key_account_manager',
                'group_key_account_manager',
                'national_key_account_manager',
                'distributor_manager',
                'general_manager',
                'vice_president',
                'regional_distributor_manager',
              ].includes(userRole) ? (
                <Button
                  type="primary"
                  rounded={true}
                  buttonStyle={{ width: 100 }}
                  title={
                    <SociollaText
                      type="bold"
                      style={{ fontSize: 14, color: Colors.white }}>
                      Edit
                    </SociollaText>
                  }
                  onPress={() => goToForm()}
                />
              ) : (
                false
              )}
            </Layout.Title>
            <View
              style={[
                styles.rowContainer,
                styles.rowBorderBottom,
                { justifyContent: isWeb ? 'flex-start' : 'space-between' },
              ]}>
              {tabs.map((item, idx) => (
                <TouchableOpacity
                  activeOpacity={0.6}
                  style={[
                    styles.tabItem,
                    activeTab == item.key ? styles.tabItemActive : {},
                    isWeb ? { width: 175 } : {},
                  ]}
                  key={idx}
                  onPress={() => setActiveTab(item.key)}>
                  <SociollaText
                    style={[
                      styles.tabText,
                      activeTab == item.key ? styles.tabTextActive : {},
                      isWeb ? { alignSelf: 'center' } : {},
                    ]}>
                    {item.name}
                  </SociollaText>
                </TouchableOpacity>
              ))}
            </View>
            {activeTab == 1 ? (
              <View
                style={{
                  width: isWeb ? 400 : '100%',
                  paddingVertical: 15,
                  paddingHorizontal: isWeb ? 25 : 15,
                }}>
                <ItemDetail
                  name="Branch Code"
                  value={detailData.branch_code ? detailData.branch_code : '-'}
                />
                <ItemDetail
                  name="Head Branch"
                  value={
                    detailData.branch_head && detailData.branch_head.name
                      ? detailData.branch_head.name
                      : '-'
                  }
                />
                <ItemDetail
                  name="Regional/Area"
                  value={detailData.regional ? detailData.regional : '-'}
                />
                <ItemDetail
                  name="Sales Team"
                  value={
                    detailData.sales_team && detailData.sales_team.length
                      ? detailData.sales_team.map((item) => item.name)
                      : []
                  }
                />
                <ItemDetail
                  name="Warehouse"
                  value={warehouses && warehouses.length ? warehouses : ['-']}
                />
                <ItemDetail
                  name="Status"
                  valueComponent={<StatusBadge status={detailData.is_active} />}
                />
              </View>
            ) : isWeb ? (
              <View
                style={{
                  width: '100%',
                  paddingHorizontal: 20,
                  paddingVertical: 25,
                }}>
                <Table
                  structures={tableStructure}
                  data={teamMembers}
                  searchPlaceholder="Search by name..."
                  withFetch={false}
                  hasCallback={true}
                  hasNoHide={true}
                  showFilter={false}
                  searchBorder={true}
                  withoutShadow={true}
                  totalData={teamMembersTemp.length}
                  limit={teamMembersTemp.length}
                  onClickRow={({ data }) => goToTeamDetail(data)}
                  onSearch={(val) => onSearch(val)}
                  slot={{
                    name: ({ data, index }) => (
                      <View
                        key={index}
                        style={{ flexDirection: 'row', alignItems: 'center' }}>
                        <Photo
                          width={photoSize}
                          height={photoSize}
                          image={data.image}
                        />
                        <SociollaText type="medium" style={styles.teamName}>
                          {data.name}
                        </SociollaText>
                      </View>
                    ),
                  }}
                />
              </View>
            ) : (
              <TableMobile
                placeholder="Search by name"
                onSearch={(val) => onSearch(val)}
                tableData={teamMembers}
                renderItem={({ data, index }) => (
                  <Layout.ItemMobile
                    key={index}
                    touchable={true}
                    left={true}
                    style={{ paddingVertical: 15 }}
                    onPress={() => goToTeamDetail(data)}>
                    <Photo
                      width={photoSize}
                      height={photoSize}
                      image={data.image}
                    />
                    <SociollaText type="medium">{data.name}</SociollaText>
                  </Layout.ItemMobile>
                )}
              />
            )}
          </>
        )}
      </Layout.Wrapper>
    </Layout.Container>
  );
};

const styles = StyleSheet.create({
  sectionWrapper: { width: '100%', padding: 15 },
  rowContainer: { flexDirection: 'row', alignItems: 'center' },
  rowBorderBottom: { borderBottomColor: Colors.grey0, borderBottomWidth: 1 },
  tabItem: {
    width: '50%',
    paddingVertical: 15,
    paddingHorizontal: 20,
    borderBottomWidth: 3,
    borderBottomColor: 'transparent',
  },
  tabItemActive: {
    borderBottomColor: Colors.blue0,
  },
  tabText: {
    fontSize: 14,
    textAlign: 'center',
  },
  tabTextActive: {
    color: Colors.blue0,
    fontFamily: 'figtree-medium',
  },
  teamItem: {
    flexDirection: 'row',
    alignItems: 'center',
    padding: 15,
    borderBottomColor: Colors.grey0,
    borderBottomWidth: 1,
  },
});

export default BranchListDetailScreen;
